import wrapInObserver from '../wrapInObserver';
import Paging from './Paging';
import generatedHooks from '../../hooks/generatedHooks';
import { pageSizes } from '../../constants/uiParams';
import logger from '../../logger';

const {
  useUiStore,
  useRatingStore,
  useRootStore,
} = generatedHooks;

const mapProps = () => {
  try {
    const {
      pageNumber,
      pageSize,
      setPageNumber,
      setPageSize,
    } = useUiStore(store => store);

    const {
      totalFirmsCount,
    } = useRatingStore(store => store);

    const pagesCount = Math.ceil(totalFirmsCount / pageSize);

    const options = Object.entries(pageSizes)
      .map(([, value]) => ({
        text: value.toString(),
        value,
      }));

    const selectedPageSize = options.filter(option => option.value === pageSize)[0];

    const rootStore = useRootStore(store => store);
    const handlePageSizeChange = (option) => {
      setPageSize(option.value);
      rootStore.init();
    };

    const handlePageNumberChange = (number) => {
      setPageNumber(number);
      rootStore.init();
    };

    return {
      pageNumber,
      pagesCount,
      options,
      selectedPageSize,
      handlePageSizeChange,
      handlePageNumberChange,
    };
  } catch (error) {
    logger.error(error);
    return {};
  }
};

export default wrapInObserver(Paging, mapProps);
